import * as queryString from 'query-string'

import { CreateNewProject, VideoProjectTemplateType, TrackingInput } from '../../../typings/types'
import { getAnalyticParams } from '../../../helpers/gaTrack'
import { getLocalPurchaseData } from '../../Purchase'

interface TrackingParams {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_referrer?: string
  sales_source?: string
  sales_medium?: string
  sales_campaign?: string
  sales_referrer?: string
  _s?: string
  _m?: string
  _c?: string
  _r?: string
}

interface SalesInitialParamsList {
  salesSource: TrackingParams & { default: string }
  salesMedium: TrackingParams & { default: string }
  salesCampaign: TrackingParams & { default: string }
  salesReferrer: TrackingParams & { default: string }
}

const salesSourceInitParams: TrackingParams & { default: string } = {
  _s: '',
  utm_source: '',
  sales_source: '',
  default: 'custom',
}

const salesMediumInitParams: TrackingParams & { default: string } = {
  _m: '',
  utm_medium: '',
  sales_medium: '',
  default: 'direct',
}

const salesCampaignInitParams: TrackingParams & { default: string } = {
  _c: '',
  utm_campaign: '',
  sales_campaign: '',
  default: '',
}

const salesReferrerInitParams: TrackingParams & { default: string } = {
  _r: '',
  utm_referrer: '',
  sales_referrer: '',
  default: '',
}

export const salesInitialParamsList: SalesInitialParamsList = {
  salesSource: salesSourceInitParams,
  salesMedium: salesMediumInitParams,
  salesCampaign: salesCampaignInitParams,
  salesReferrer: salesReferrerInitParams,
}

export const reduceSalesParams = (
  initalSalesParams: TrackingParams & { default: string },
  trackingParams: TrackingParams
): TrackingParams => {
  return Object.keys({ ...trackingParams }).reduce(
    (object, key) => {
      if (!(key in initalSalesParams)) {
        delete object[key]
      }
      return object
    },
    { ...trackingParams }
  )
}

export const getSalesParams = (trackingParams: TrackingParams): TrackingInput => {
  const salesParams = {
    salesSource: '',
    salesMedium: '',
    salesCampaign: '',
    salesReferrer: '',
  }

  for (const [key, value] of Object.entries(salesInitialParamsList)) {
    const merge: TrackingInput = { ...value, ...reduceSalesParams(value, trackingParams) }
    salesParams[key] = Object.values(merge).find(el => el.length > 0) || ''
  }

  return salesParams
}

export const getTrackingInput = (): TrackingInput => {
  const analyticParams = getAnalyticParams()
  if (analyticParams) {
    const trackingParams: TrackingParams = queryString.parse(analyticParams)
    const salesParams = getSalesParams(trackingParams)
    const trackingInput: TrackingInput = {
      salesSource: salesParams.salesSource,
      salesMedium: salesParams.salesMedium,
      salesCampaign: salesParams.salesCampaign,
      salesReferrer: salesParams.salesReferrer,
    }
    return trackingInput
  }

  const trackingInputWithoutAnalytics: TrackingInput = {
    salesSource: 'custom',
    salesMedium: 'direct',
    salesCampaign: '',
    salesReferrer: '',
  }
  return trackingInputWithoutAnalytics
}

export const getProjectVariables = (brandUuid, videoProjectTemplateType) => {
  const variables: CreateNewProject.Variables = {
    brandUuid,
    quote: getLocalPurchaseData(videoProjectTemplateType || VideoProjectTemplateType.ALL).quote,
    trackingInput: getTrackingInput(),
  }
  return variables
}

export const trimText = (text?: string, textCount: number = 250): string =>
  text && text.length <= textCount ? text : text ? `${text.substr(0, textCount)} ...` : `...`



// WEBPACK FOOTER //
// ./src/components/SelectBrands/helpers/project-helpers.ts